import { getRegulations,insertRegulations,deleteRegulations } from "../../api/config/modules/PolicyRule";

const state = {
    getRegulations: {},
    insertRegulations: {},
    deleteRegulations: {}
};

const mutations = {
    SET_GETREGULATIONS: (state, getRegulations) => {
        state.getRegulations = getRegulations;
    },
    SET_INSERTREGULATIONS: (state, insertRegulations) => {
        state.insertRegulations = insertRegulations;
    },
    SET_DELETEREGULATIONS: (state, deleteRegulations) => {
        state.deleteRegulations = deleteRegulations;
    },
};

const actions = {
    GET_GETREGULATIONS: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            getRegulations(data)
                .then((res) => {
                    commit("SET_GETREGULATIONS", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTREGULATIONS: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertRegulations(data)
                .then((res) => {
                    commit("SET_INSERTREGULATIONS", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEREGULATIONS: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteRegulations(data)
                .then((res) => {
                    commit("SET_DELETEREGULATIONS", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
